export class UserModel {
  id: string;
  phone: string;
  emailAddress: string;
  surname: string;
  givenName: string;
  logonName: string;
  allowLogon: boolean;
  enabled: boolean;
  organisationId: string;
  organisationName: string;
  mfa: boolean;
  jobtitle?: string;
  department?: string;
  additionalInformation?: string;

  static validate(user: UserModel) {
    if (user.givenName == null) {
      return false;
    }

    user.givenName = user.givenName.trim();
    if (user.givenName === '') {
      user.givenName = null;
      return false;
    }

    if (user.surname == null) {
      return false;
    }

    user.surname = user.surname.trim();
    if (user.surname === '') {
      user.surname = null;
      return false;
    }

    if (!user.id) {
      if (user.logonName == null) {
        return false;
      }

      user.logonName = user.logonName.trim();
      if (user.logonName === '') {
        user.logonName = null;
        return false;
      }
    }

    if (user.emailAddress == null) {
      return false;
    }

    user.emailAddress = user.emailAddress.trim();
    if (user.emailAddress === '') {
      user.emailAddress = null;
      return false;
    }

    if (user.jobtitle) {
      user.jobtitle = user.jobtitle.trim();
      if (user.jobtitle === '') {
        user.jobtitle = null;
      } else if (user.jobtitle.length > 100) {
        return false;
      }
    }

    if (user.department) {
      user.department = user.department.trim();
      if (user.department === '') {
        user.department = null;
      } else if (user.department.length > 100) {
        return false;
      }
    }

    if (user.additionalInformation) {
      user.additionalInformation = user.additionalInformation.trim();
      if (user.additionalInformation === '') {
        user.additionalInformation = null;
      } else if (user.additionalInformation.length > 500) {
        return false;
      }
    }

    return true;
  }
}

export class ChangePasswordModel {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export class ActiveUsersModel {
  activeUsers: number;
}

export class UserInfoModel {
  user: UserModel;
  permissions: any;
}

export class AdminUserModel extends UserModel {
  password?: string;
  telephoneNumber: string;
  sendEmail?: boolean;

  static override validate(user: AdminUserModel): boolean {
    if (
      !user.givenName ||
      !user.surname ||
      !user.emailAddress ||
      !user.logonName
    ) {
      return false;
    }

    const emailRegex = /\S+@\S+\.\S+$/;

    if (!emailRegex.test(user.emailAddress)) {
      return false;
    }

    if (user.logonName && !emailRegex.test(user.logonName)) {
      return false;
    }

    return true;
  }

  constructor(override?: Partial<AdminUserModel>) {
    super();

    if (override) {
      Object.assign(this, override);
    }
  }
}

export interface UserPermission {
  user: string;
  permissions: string[];
}
